import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialogConfig, MatDialog } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { OrderService } from '../_ecomservices/order.service';
import { LoadingService } from '../../_services/loading.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/_services/notification.service';
import { DeliveryVehicleService } from '../_ecomservices/delivery-vehicle.service';
import { OrderEditComponent } from '../order-edit/order-edit.component';

@Component({
  selector: 'app-order-assigned-for-delivery',
  templateUrl: './order-assigned-for-delivery.component.html',
  styleUrls: ['./order-assigned-for-delivery.component.css']
})
export class OrderAssignedForDeliveryComponent implements OnInit {

  displayedColumns: string[] = ['select', 'TrackingNo', 'AssignmentDate', 'CustomerName', 'Mobile', 'Action'];

  totalCrate: number = 0;
  orderSelection = new SelectionModel<any>(true, []);
  deliveryVehicleList = [];
  selecteddeliveryVehicle: number = 0;
  orderStatusList: number = 0;
  selectedOrderStatus: number = 0;

  dataSource: MatTableDataSource<any>;
  searchKey: string;

  order_status_form = new FormGroup({
    id: new FormControl(null),
    order_status: new FormControl('', [Validators.required]),
    shipping_status: new FormControl(''),
    created_at: new FormControl(''),
  });

  constructor(
    private titleService: Title,
    private dialog: MatDialog,
    public orderService: OrderService,
    private loading: LoadingService,
    private deliveryVehicleService: DeliveryVehicleService,
    public datePipe: DatePipe,
    private notificationService: NotificationService,
    private route: ActivatedRoute,) { }


  ngOnInit() {
    this.titleService.setTitle('Order List');
    this.onLoadVehicles();
    this.dataSource = new MatTableDataSource<any>([]);
  }

  onLoadVehicles() {
    //console.log('ok');
    var result = this.deliveryVehicleService.delivery_active_vehicles().subscribe(data => {
      this.deliveryVehicleList = data['vehicles'];
    });
  }

  onChangeVehicle() {
    let vehDetails = this.deliveryVehicleList.find(x => x.id === this.selecteddeliveryVehicle);
    if (vehDetails) {
      this.onLoadOrders();
    }
  }

  onLoadOrders() {
    console.log(this.selecteddeliveryVehicle);
    // this.loading.spin$.next(true);
    var result = this.orderService.get_delivery_orders(this.selecteddeliveryVehicle).subscribe(data => {
      console.log(data);
      this.dataSource = new MatTableDataSource<any>(data['orders']);
      this.orderStatusList = data['next_status_list'];
      this.loading.spin$.next(false);
    });
  }

  onEditOrder(row) {
    let isEditItemOnly = true;
    if (row.order_status == 2) {
      isEditItemOnly = false;
    }
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "99%";
    matDialogConfig.position = { top: '0px' };
    matDialogConfig.data = { order_id: row.order_id, isEditItemOnly: isEditItemOnly };
    this.dialog.open(OrderEditComponent, matDialogConfig).afterClosed().subscribe(res => {
      // console.log(res);
      this.onLoadOrders();
    });
  }


  onChangeOrderSelection($event, row) {
    console.log(row);
    $event ? this.orderSelection.toggle(row) : null;
    if ($event.checked) {
      //  this.totalCrate = this.totalCrate + row.total_crate;
    }
    else {
      //  this.totalCrate = this.totalCrate - row.total_crate;
    }
    this.totalCrate = 0;
    this.orderSelection.selected.forEach(element => {
      //  this.totalCrate += element.total_crate;
    });
    console.log(this.totalCrate);
  }


  onUpdateForShipment() {
    if (this.orderSelection.selected.length > 0) {
      if (this.selecteddeliveryVehicle <= 0) {
        this.notificationService.warn('Please selecte delivery vehicle');
      }
      else if (this.selectedOrderStatus <= 0) {
        this.notificationService.warn('Please selecte order status');
      }
      else {
        this.loading.spin$.next(true);
        console.log(this.orderSelection.selected);
        this.orderService.order_shipped(this.orderSelection.selected, this.selectedOrderStatus).subscribe(data => {
          if (data['status']) {
            this.orderSelection.clear();
            this.totalCrate = 0;
            // this.selecteddeliveryVehicle = 0;
            this.selectedOrderStatus = 0;
            this.onLoadOrders();
            this.notificationService.success(data['message']);
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
    }
    else {
      this.notificationService.warn('Please selecte order for asign to delivery');
    }
  }


}
